import React, { Component, useEffect, useState } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import { tender_cat_data, tender_cate_data, tender_org_data, tender_orgn_data, user_tenders_list } from "../user.api";
import "./tenders.css";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { Toast } from "bootstrap";
import BreadCrumpBack from "../../../components/navigator/back";

class tenders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      orgdata: [],
      catdata: [],
      url: "",
      selectedOrgId: "",
      selectedCatId: "",
    };
  }
  componentDidMount = () => {
    this.fetchTender();
    this.fetchOrganisation();
    this.fetchCategory();
  };

  fetchTender = (orgId = "", catId = "") => {
    user_tenders_list().then((res) => {
      const currentDate = moment();

      const filteredData = res?.data.filter((item) => {
        const isPublic = item.type === "public";
        const isPublished = item.tender_publish_status === 1;
        const isFuture = moment(item?.due_date, "YYYY-MM-DD").isAfter(currentDate);
        const matchesOrg = orgId ? item.organisation?.id == orgId : true;
        const matchesCat = catId ? item.category?.id == catId : true;

        return isPublic && isPublished && isFuture && matchesOrg && matchesCat;
      });

      this.setState({
        data: filteredData,
        url: res.current_url,
      });
    });
  };

  fetchOrganisation = () => {
    tender_orgn_data().then((res) => {
      const names = res.map((item) => item.name);
      this.setState({
        orgdata: res, 
      });
    }).catch((err) => {
      console.error('Error fetching data:', err);
    });
  }
  fetchCategory = () => {
    tender_cate_data().then((res) => {
      const names = res.map((item) => item.name);
      this.setState({
        catdata: res, 
      });
    }).catch((err) => {
      console.error('Error fetching data:', err);
    });
  }

  handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  handleDownloadProof = (file) => {
    const servInstance = process.env.REACT_APP_BASE_URL;
    let result = servInstance.substring(0, servInstance?.length - 4);
    let path = `${result}${file}`;
    window.open(path, "_blank");
  };
  formatAmount(amount) {
    return new Intl.NumberFormat('en-IN').format(amount);
  };
  handleOrganisationChange = (e) => {
    const selectedOrgId = e.target.value;
    this.setState({ selectedOrgId }, () => {
      this.fetchTender(selectedOrgId, this.state.selectedCatId);
    });
  };
  handleCategoryChange = (e) => {
    const selectedCatId = e.target.value;
    this.setState({ selectedCatId }, () => {
      this.fetchTender(this.state.selectedOrgId, selectedCatId);
    });
  };
  render() {
    const { data, url} = this.state;
    const { state } = this.props;
    const { orgdata, selectedOrgId } = this.state;
    const { catdata, selectedCatId } = this.state;
    const currentDate = moment()
    return (
      <div className="tender bg-tender">
        <div>
          <div className="dash-banner ">
            <div className="tix">{this.props.state.language==="ma"?"ടെൻഡറുകൾ":"Tenders"}</div>
          </div>
        </div>
        <BreadCrumpBack />
        <div className="container p-50">

          <div className="bg-white">
            <div className="row tender-box">
              {data?.length != 0 ? (
                <>
                  {data?.map((item, i) => (
                    <React.Fragment key={i}>

                      {item.tender_publish_status === 1 &&
                        item?.type === "public" &&
                        moment(item?.due_date, "YYYY-MM-DD").isAfter(
                          currentDate
                        ) && (
                          <div className="bg-tender p-30">
                            <div className="tender-title mb-2">
                              <p className="head ">
                                <u>{this.props.state.language === "ma" ? item?.title_ma : item?.tender_title}</u>
                              </p>
                            </div>
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Tender By</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                <p>{this.props.state.language === "ma" ? item?.organized_by_ma : item?.organized_by}</p>
                              </div>
                            </div>
                            {item?.value_of_tender &&
                              item?.value_of_tender != 0 && (
                                <div className="tender-datas">
                                  <div className="col-lg-2 col-md-12 col-sm-12 label">
                                    <p>Value of Tender</p>
                                  </div>
                                  <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                    <p>₹ {this.formatAmount(item?.value_of_tender)}</p>
                                  </div>
                                </div>
                              )}
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Description</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>
                                  {this.props.state.language === "ma"
                                    ? item?.description_ma && ReactHtmlParser(item?.description_ma)
                                    : item?.description && ReactHtmlParser(item?.description)}
                                </p>
                              </div>
                            </div>
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Due Date</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>{item?.due_date ? moment(item?.due_date, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm") : "--"}</p>
                              </div>
                            </div>
                            {item?.link && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Link</p>
                                </div>

                                <div className="d-flex   col-lg-10 col-md-12 col-sm-12 contentx overf">
                                  <p className="blink_me ">
                                    <CustomIcons iconName={"hand"} />
                                  </p>

                                  <span className="">
                                    &nbsp;
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault(); 
                                        const url = /^https?:\/\//.test(item.link) ? item.link : `https://${item.link}`;
                                        window.open(url, "_blank");
                                      }}
                                      className="break_link"
                                    >
                                      {item?.link}
                                    </a>
                                  </span>
                                </div>
                              </div>
                            )}
                            {item?.file && item?.file !== "storage/" && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Document</p>
                                </div>
                                {item?.file && (
                                  <div className="d-flex align-items-center col-lg-10 col-md-12 col-sm-12 contentx overf">
                                    <p className="blink_me">
                                      <CustomIcons iconName={"hand"} />
                                    </p>

                                    <span className="">
                                      &nbsp;
                                      <a
                                        onClick={(e) =>
                                          this.handleDownloadProof(item?.file)}
                                        className="break_link"
                                      >
                                        {" "}
                                        Download
                                      </a>
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                    </React.Fragment>
                  ))}
                </>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default tenders;
